module.exports = __webpack_public_path__ + "60a51ee634ab2a8bb9f1f1c74cb87c50.ttf";